import React from 'react'
import { Modal, Row, Card } from 'antd'
import _ from 'lodash'
import { MaterialItem } from '../../../styles/shared.style'

const PickMaterialSecond = (props) => {
  const {
    visible,
    categories,
    onClose,
    materialLinkList,
    setMaterialLinkList
  } = props

  const renderItemActive = (item) => {
    let active = false

    materialLinkList.forEach((material) => {
      if (material.id === item.id) {
        active = true
      }
    })

    return active
  }

  function onClickItem(material) {
    const added = _.find(materialLinkList, (item) => {
      return item.id === material.id
    })

    if (added) {
      const arr = materialLinkList.filter((item) => item.id !== material.id)
      setMaterialLinkList(arr)
    } else {
      setMaterialLinkList((prevState) => {
        prevState.push(material)

        return [...prevState]
      })
    }
  }

  return (
    <Modal
      title="เลือกวัสดุ"
      visible={visible}
      destroyOnClose
      width={1000}
      onOk={onClose}
      onCancel={onClose}>
      <Card style={{ marginTop: 10, height: 450, overflowY: 'scroll' }}>
        {!_.isEmpty(categories) &&
          categories.map((item, index) => {
            return (
              <Row key={index} type="flex">
                <Row style={{ width: '100%' }}>
                  <span style={{ color: 'green', fontSize: 18 }}>
                    {item.categoryName}
                  </span>
                </Row>
                {item.materialList.map((material, idx) => {
                  return (
                    <MaterialItem
                      key={idx}
                      active={renderItemActive(material)}
                      onClick={() => onClickItem(material)}>
                      {material.name}
                    </MaterialItem>
                  )
                })}
              </Row>
            )
          })}
      </Card>
    </Modal>
  )
}

export default PickMaterialSecond



// WEBPACK FOOTER //
// ./src/pages/MaterialLink/MaterialLinkListForm/index.js